// reducers
function appticker(state = {}, action) {
  switch (action.type) {
    case 'APPTICKER':
      return action.payload;

    default:
      return state;
  }
}

export default appticker;
